<template>
  <div class="staff-orders">
    <el-card shadow="never">
      <div class="page-header">
        <h3>会员订单</h3>
        <p v-if="currentStaff" class="staff-info">{{ currentStaff.staffName || currentStaff.staffId }}（{{ currentStaff.phoneNumber }}）</p>
      </div>
      <template v-if="!currentStaffId">
        <el-empty v-if="!currentLoading" description="当前账号未关联会员，无法查看订单" />
      </template>
      <el-tabs v-else v-model="activeTab">
        <el-tab-pane label="个人订单" name="personal">
          <el-table :data="personalOrderList" v-loading="personalLoading" border stripe>
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="studentName" label="学生姓名" min-width="100" />
            <el-table-column prop="sourceName" label="来源" width="120" />
            <el-table-column prop="projectCodesNames" label="咨询课程" min-width="140" show-overflow-tooltip />
            <el-table-column prop="createTime" label="咨询时间" width="160" />
            <el-table-column label="所在城市" min-width="120">
              <template slot-scope="{ row }">
                {{ formatCity(row) }}
              </template>
            </el-table-column>
          </el-table>
          <el-empty v-if="!personalLoading && !personalOrderList.length" description="暂无个人订单" />
        </el-tab-pane>
        <el-tab-pane label="团队订单" name="team">
          <el-table :data="teamOrderList" v-loading="teamLoading" border stripe>
            <el-table-column type="index" label="序号" width="60" />
            <el-table-column prop="studentName" label="学生姓名" min-width="100" />
            <el-table-column prop="sourceName" label="来源" width="120" />
            <el-table-column prop="projectCodesNames" label="咨询课程" min-width="140" show-overflow-tooltip />
            <el-table-column prop="createTime" label="咨询时间" width="160" />
            <el-table-column label="所在城市" min-width="120">
              <template slot-scope="{ row }">
                {{ formatCity(row) }}
              </template>
            </el-table-column>
            <el-table-column prop="referrerName" label="推荐人" width="120" />
          </el-table>
          <el-empty v-if="!teamLoading && !teamOrderList.length" description="暂无团队订单" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'StaffOrders',
  data() {
    return {
      currentStaff: null,
      currentStaffId: '',
      currentLoading: false,
      activeTab: 'personal',
      personalOrderList: [],
      personalLoading: false,
      teamOrderList: [],
      teamLoading: false
    };
  },
  watch: {
    currentStaffId(val) {
      if (val) {
        this.loadPersonalOrders();
        this.loadTeamOrders();
      }
    },
    '$route.query.staffId'(staffId) {
      if (staffId) {
        this.loadStaffById(staffId);
      } else {
        this.loadCurrentStaff();
      }
    }
  },
  mounted() {
    const staffIdFromQuery = this.$route.query.staffId;
    if (staffIdFromQuery) {
      this.loadStaffById(staffIdFromQuery);
    } else {
      this.loadCurrentStaff();
    }
  },
  methods: {
    async loadStaffById(staffId) {
      this.currentLoading = true;
      try {
        const res = await api.post(`/staff/${staffId}`, {});
        if (res.data && res.data.success && res.data.data) {
          this.currentStaff = res.data.data;
          this.currentStaffId = res.data.data.staffId;
        } else {
          this.currentStaff = null;
          this.currentStaffId = '';
          this.$message.error('会员不存在');
        }
      } catch (e) {
        this.currentStaff = null;
        this.currentStaffId = '';
        this.$message.error(e.response?.data?.message || '获取会员信息失败');
      }
      this.currentLoading = false;
    },
    async loadCurrentStaff() {
      this.currentLoading = true;
      try {
        const res = await api.post('/staff/current', {});
        if (res.data && res.data.success && res.data.data) {
          this.currentStaff = res.data.data;
          this.currentStaffId = res.data.data.staffId;
        } else {
          this.currentStaff = null;
          this.currentStaffId = '';
        }
      } catch (e) {
        this.currentStaff = null;
        this.currentStaffId = '';
        if (e.response && e.response.status !== 401) {
          this.$message.error(e.response?.data?.message || '获取当前会员失败');
        }
      }
      this.currentLoading = false;
    },
    async loadPersonalOrders() {
      if (!this.currentStaffId) return;
      this.personalLoading = true;
      try {
        const res = await api.post('/student/list', {
          referrerStaffId: this.currentStaffId,
          page: 1,
          pageSize: 1000
        });
        if (res.data && res.data.success) {
          const payload = res.data.data;
          this.personalOrderList = Array.isArray(payload) ? payload : (payload && payload.list) || [];
        }
      } catch (e) {
        this.$message.error('加载个人订单失败');
      }
      this.personalLoading = false;
    },
    async loadTeamOrders() {
      if (!this.currentStaffId) return;
      this.teamLoading = true;
      try {
        const res = await api.post('/student/list', {
          referrerStaffIdTeamLead: this.currentStaffId,
          page: 1,
          pageSize: 1000
        });
        if (res.data && res.data.success) {
          const payload = res.data.data;
          this.teamOrderList = Array.isArray(payload) ? payload : (payload && payload.list) || [];
        }
      } catch (e) {
        this.$message.error('加载团队订单失败');
      }
      this.teamLoading = false;
    },
    formatCity(row) {
      const parts = [row.provinceName, row.cityName, row.districtName].filter(Boolean);
      return parts.length ? parts.join(' ') : (row.cityCode || '-');
    }
  }
};
</script>

<style scoped>
.staff-orders {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.page-header h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
}
.staff-info {
  margin: 0;
  color: #909399;
  font-size: 14px;
}
</style>
